<template>
<div v-if="step==='AUTH'" class="window formWrap" >
  <div class="vk-auth-container">
  <div v-if="showVkTestButton">
    <vk-auth-button
      ref="vkAuthButton"
      @auth-success="handleVkAuthSuccess"
      @auth-error="handleVkAuthError"
      title="Войти с VK ID"
      :disabled="!areAllCheckboxesAccepted()"
      :validate="checkAllCheckboxes"
      @validation-failed="handleValidationFailed"
    />
  </div>
  </div>
  <div class="d-flex flex-column blockWrapper">
    <h4 class="formSubtitle">Авторизация</h4>
    <p class="info-note ">Вам будет отправлен код для подтверждения вашего номера</p>
  </div>
  <div class="contacts contacts__modal">
    <div class="contact__inputs">
      <MyInput
         label="Телефон"
         ref="phoneInput"
         phone-input
         data-tel-input
         autocomplete="tel"
         type="tel"
         maxlength="18"
         v-model="userPhone"
         v-on:keyup.enter="sendPhone"
      ></MyInput>
    </div>
    <div v-if="errorPhoneModal" class="invalid-feedback">ЧТО-ТО НЕ ТАК!</div>
  </div>
  <my-button type="button" @click="sendPhone" class="w-100" id="submit_phone_and_name_btn">
    <span>
      ОТПРАВИТЬ КОД
    </span>
    <span v-if="pending" class="spinner-grow spinner-grow-sm ms-3" role="status" aria-hidden="true"></span>
  </my-button>
<div
  class="policy-box"
  :class="{
    'policy-box--error': policyError,
    'policy-box--active': isPolicyAccepted
  }"
  @click="isPolicyAccepted = !isPolicyAccepted"
>
  <div class="policy-checkbox">
    <svg
      v-if="isPolicyAccepted"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  </div>

  <div class="policy-text">
    Ознакомлен и принимаю условия
    <a href="#" @click.prevent="showPolicyModal = true">
      политики обработки персональных данных
    </a>
  </div>
</div>

<div
  class="policy-box"
  :class="{
    'policy-box--error': personalDataError,
    'policy-box--active': isPersonalDataAccepted
  }"
  @click="isPersonalDataAccepted = !isPersonalDataAccepted"
>
  <div class="policy-checkbox">
    <svg
      v-if="isPersonalDataAccepted"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  </div>

  <div class="policy-text">
    Согласен на обработку
    <a href="#" @click.prevent="showPersonalDataModal = true">
      персональных данных
    </a>
  </div>
</div>
</div>



<div v-if="step==='CONFIRM'" class="window formWrap" >
  <div class="d-flex flex-column blockWrapper">
    <h4 class="formSubtitle">Авторизация</h4>
    <p v-if="codeSendBy==='whatsapp'" class="info-note ">Введите 4-х значный код, отправленный вам в WhatsApp на номер <strong>{{userPhone}}</strong>, для подтверждения.</p>
    <p v-else-if="codeSendBy==='sms_aero'" class="info-note ">Введите 4-х значный код, отправленный вам в SMS на номер <strong>{{userPhone}}</strong>, для подтверждения.</p>
    <p v-else-if="codeSendBy==='flash_call'" class="info-note ">Авторизация через вызов. На номер <strong>{{userPhone}}</strong> поступит звонок. Введите последние 4-ре цифры номера входящего звонка.</p>
    <p v-else class="info-note ">Введите 4-х значный код, отправленный вам на номер <strong>{{userPhone}}</strong>, для подтверждения.</p>
    <p v-if="errorCodeModal" class="info-note mb-0 mt-3 py-2 alert alert-danger">{{errorCodeModal}}</p>
  </div>
  <div class="position-relative">
  <MyInput label="Код подтверждения"
           ref="inputCode"
           phone-input
           type="text"
           v-model="validateCode"
           v-on:keyup.enter="sendValidateCode"
           maxlength="4"
           class="nameModal"
           id="validCodeModal"
           autocomplete="off"
  ></MyInput>
  <div class="loaderInInput">
    <span v-if="pending" class="spinner-grow spinner-grow-sm ms-3" role="status" aria-hidden="true"></span>
  </div>
  </div>

  <my-button :cls="!canResendCode?'hollow':''" @click="sendPhone" class="w-100">
    <span>ОТПРАВИТЬ СНОВА</span>
    <span v-if="resendTimer" class="ms-3">{{resendTimer}}</span>
  </my-button>
</div>

<div v-if="step==='USERNAME'" class="window formWrap">
    <h4 class="formTitle">Авторизация</h4>
      <div class="d-flex flex-column">
        <p class="formSubtitle">Мы еще не знакомы.<br> Напишите ваше имя.</p>
      </div>
      <div class="position-relative">

      <MyInput label="Имя"
               ref="inputName"
               name-input
               type="text"
               maxlength="18"
               v-model="userName"
               v-on:keyup.enter="setUserName"
               class="nameModal mb-4" id="nameModal" placeholder="Имя" autocomplete="off"
      ></MyInput>
      <div class="loaderInInput">
        <span v-if="pending" class="spinner-grow spinner-grow-sm ms-3" role="status" aria-hidden="true"></span>
      </div>
      </div>
    <div class="modal-footer set-name-footer">
      <my-button @click="setUserName" type="button" class="btn btn-primary" id="submit_name__btn">
          <span>
              Сохранить
          </span>
      </my-button>
    </div>
  </div>

<transition name="fade">
  <div
    v-if="showPolicyModal"
    class="policy-modal-overlay"
    @click="showPolicyModal = false"
  >
    <div
      class="policy-modal"
      @click.stop
    >

      <button
        class="policy-modal-close"
        @click="showPolicyModal = false"
      >
        ×
      </button>

      <h2 class="policy-modal-title">
        Политика обработки персональных данных
      </h2>

      <div class="policy-modal-content">

          <p><b>Политика обработки персональных данных</b></p>

          <p><b>1. Общие положения</b></p>

          <p>1.1. Настоящая Политика обработки персональных данных (далее — Политика) разработана в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» (далее — Закон о ПДн).</p>

          <p>1.2. Политика определяет порядок обработки персональных данных (далее — ПДн) и меры по обеспечению их безопасности оператором.</p>

          <p>1.3. Оператор обрабатывает ПДн на законных основаниях, в том числе на основании согласия субъекта ПДн.</p>

          <p><b>2. Принципы обработки ПДн</b></p>

          <p>2.1. Обработка осуществляется в целях, заранее определённых и явных, и не допускается без ПДн, несовместимая с этими целями.</p>

          <p>2.2. Обработка ограничена достижением целей, точностью и достаточностью ПДн для этих целей.</p>

          <p><b>3. Категории и цели обработки ПДн</b></p>

          <p>3.1. Оператор обрабатывает следующие категории ПДн:</p>

          <p>Общие ПДн: ФИО (имя, фамилия, отчество по желанию), номер телефона, идентификатор профиля ВКонтакте (VK ID) — для создания учётной записи, аутентификации и связи с пользователем (далее — Цель 1).</p>

          <p>Технические данные: cookies, IP-адрес, данные о поведении на сайте — для аналитики с использованием Яндекс.Метрика (далее — Цель 2).</p>

          <p>3.2 Необходимые cookies: session (сессия), csrf_token (безопасность) — для работы сайта без согласия.</p>

          <p>Аналитические: ym... — только с согласия</p>

          <p>3.3. Пользователь может отказаться от предоставления телефона или VK ID — обработка ведётся только по предоставленным данным.</p>

          <p><b>4. Правовые основания и условия обработки</b></p>

          <p>4.1. Обработка ПДн осуществляется на основании Согласия субъекта ПДн (ст. 9 Закона о ПДн);</p>

          <p>4.2. Согласие даётся путём проставления отметки в чекбоксе на сайте или кнопкой в cookie-плашке.</p>

          <p><b>5. Способы и порядок обработки</b></p>

          <p>5.1. Обработка включает сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение, использование, передачу (предоставление), обезличивание, блокирование, удаление, уничтожение ПДн.</p>

          <p>5.2. Обработка автоматизированная (с использованием сайта и сервисов) и неавтоматизированная.</p>

          <p>5.3. Передача третьим лицам: VK для авторизации (по API), Яндекс для аналитики (анонимизировано).</p>

          <p><b>6. Сроки обработки</b></p>

          <p>6.1. Для Цели 1 — до отзыва согласия или удаления учётки.</p>

          <p>6.2. Для Цели 2 — в соответствии с настройками Яндекс.Метрика (до 24 месяцев) или отзыва согласия.</p>

          <p><b>7. Меры по защите ПДн</b></p>

          <p>7.1. Оператор применяет организационные и технические меры: шифрование, доступ по ролям, резервное копирование, антивирусную защиту.</p>

          <p><b>8. Права субъекта ПДн</b></p>

          <p>8.1. Субъект имеет право на доступ, уточнение, блокирование, удаление ПДн, отзыв согласия, обжалование.</p>

          <p>8.2. Обращения направлять на email оператора. Ответ в течение 30 дней.</p>

          <p><b>9. Заключительные положения</b></p>

          <p>9.1. Политика действует бессрочно с момента публикации.</p>

          <p>9.2. Актуальная редакция размещена на сайте.</p>

          <p><b>Реквизиты оператора</b></p>

          <p>Индивидуальный предприниматель Кучугура Александр Валерьевич</p>

          <p>ОГРНИП: 309615422200057</p>

          <p>ИНН: 615421105579</p>

          <p>Адрес для обращений: kuchugura.alexander@gmail.com</p>

      </div>
    </div>
  </div>
</transition>

<transition name="fade">
  <div
    v-if="showPersonalDataModal"
    class="policy-modal-overlay"
    @click="showPersonalDataModal = false"
  >
    <div
      class="policy-modal"
      @click.stop
    >

      <button
        class="policy-modal-close"
        @click="showPersonalDataModal = false"
      >
        ×
      </button>

      <h2 class="policy-modal-title">
        Согласие на обработку персональных данных
      </h2>

      <div class="policy-modal-content">
            <p><b>СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ</b></p>

            <p>Я,  _</p>

            <p>даю согласие Оператору на обработку моих персональных данных в следующих объёмах и целях.</p>

            <p><b>Цели обработки:</b></p>

            <p>Создание учётной записи и связь со мной по вопросам барной викторины (аутентификация, информирование).</p>

            <p>Аналитика посещаемости сайта (Яндекс.Метрика).</p>

            <p><b>Перечень персональных данных:</b></p>

            <p>Имя</p>

            <p>Отчество, Фамилия - опционально</p>

            <p>Номер телефона (для логина и связи)</p>

            <p>Идентификатор профиля ВКонтакте (VK ID, для логина)</p>

            <p>Cookies, IP-адрес, данные поведения (для аналитики).</p>

            <p><b>Перечень действий:</b> сбор, запись, систематизация, хранение, уточнение, извлечение, использование, обезличивание, удаление ПДн (автоматизированная и смешанная обработка).</p>

            <p><b>Третьи лица (передача):</b></p>

            <p>ВКонтакте (для авторизации по API);</p>

            <p>Яндекс (для аналитики, анонимизировано).</p>

            <p>Я ознакомлен с Политикой обработки ПДн [ссылка], понимаю, что:</p>

            <p>Обработка ведётся на основании моего согласия (ст. 9 152-ФЗ);</p>

            <p>Срок действия — до отзыва (или 24 мес. для аналитики);</p>

            <p>Могу отозвать согласие в любой момент по email оператора, обработка прекратится в 30 рабочих дней.</p>

            <p>Дата: _</p>

            <p>Электронное подтверждение: проставлением отметки «Согласен» и нажатием кнопки регистрации/принятия.</p>

            <p><b>Реквизиты оператора:</b> ИП Кучугура Александр Валерьевич, ОГРНИП 309615422200057, ИНН 615421105579, email: kuchugura.alexander@gmail.com</p>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import {mapActions} from "vuex";
import MyInput from "@/components/UI/MyInput";
import VkAuthButton from "@/components/VkAuthButton";

const TIMEOUT = 5

export default {
  name: "Login",
  components: {MyInput, VkAuthButton},
  data: function () {
    return {
      step: 'AUTH',
      userPhone: '',
      validateCode: '',
      userName: '',
      errorPhoneModal: '',
      errorCodeModal: '',
      resolvePromise: undefined,
      rejectPromise: undefined,
      pending: false,
      canResendCode: false,
      lastResendTimer: 0,
      resendTimer: TIMEOUT,
      resendTimerInterval: null,
      codeSendBy: null,
      showVkTestButton: false,
      isPolicyAccepted: false,
      policyError: false,
      showPolicyModal: false,
      isPersonalDataAccepted: false,
      personalDataError: false,
      showPersonalDataModal: false,
    }
  },
  watch: {
    validateCode() {
      if (`${this.validateCode}`.length>3) this.sendValidateCode();
    },
    step(step){
      if (step==='CONFIRM'){
        this.startTimer()
      }
    }
  },
  mounted() {
    this.auth()
    this.checkVkButtonVisibility()
  },
  methods: {
    checkVkButtonVisibility() {
      // Проверяем видимость кнопки через бэкенд для безопасности
      this.$api.checkVkAuthButtonVisibility()
        .then((response) => {
          this.showVkTestButton = response.show_vk_button || false
        })
        .catch((error) => {
          console.warn('Failed to check VK button visibility:', error)
          // Fallback: проверка через cookie для локального тестирования
          this.showVkTestButton = this.hasVkTestCookie()
        })
    },
    hasVkTestCookie() {
      // Fallback метод для локального тестирования
      return document.cookie.split(';').some(c => c.trim().startsWith('show_test_vk_button='))
    },
    ...mapActions([
      'SET_USER_TOKEN',
      'SET_USER_FIELDS',
      'GET_USER_DETAILS',
      'SHOW_AUTH_MODAL'
    ]),
    startTimer(){
      if (this.resendTimerInterval) clearInterval(this.resendTimerInterval)
      this.canResendCode = false
      this.lastResendTimer += TIMEOUT
      this.resendTimer = this.lastResendTimer
      this.resendTimerInterval = setInterval(()=>{
        if (this.resendTimer>0){
          this.resendTimer-=1
        } else {
          this.canResendCode=true
          clearInterval(this.resendTimerInterval)
        }
      }, 1000)
    },
    auth() {
      this.step = 'AUTH';
      this.$nextTick(()=> {
        this.$refs.phoneInput.focus();
        this.glb.phoneInputFormatter();
      });
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    sendPhone: function () {
      let vm = this;
      if (!vm.checkPolicyAccepted()) return
      if (!vm.checkPersonalDataAccepted()) return
      if (vm.pending || (vm.step==='CONFIRM' && !vm.canResendCode)) return
      vm.pending = true
      vm.$logApi.log({
        logs:{
          event: 'user login',
          phone: vm.userPhone,
          timestamp: new Date().toISOString(),
        }
      })
      vm.$api.getOrCreateUser(vm.userPhone, '')
        .then((res)=>{
            vm.codeSendBy = res.send_by
            vm.step = 'CONFIRM'
            vm.$nextTick(()=>vm.$refs.inputCode.focus())
        })
        .catch(function (error) {
          if (error.response.data){
            let errorMessage = ''
              for (let key in error.response.data) {
                errorMessage += `${key}: ${error.response.data[key]}\n`
              }
              console.log('auth error')
              console.log(errorMessage)
              vm.$toast.error("Что-то пошло не так на нашей стороне. Мы уже чиним, попробуйте авторизоваться чуть позже, спасибо!")
          } else {
            console.log('auth error')
            console.log(error)
            vm.$toast.error("Что-то пошло не так на нашей стороне. Мы уже чиним, попробуйте авторизоваться чуть позже, спасибо!")
          }
          console.log("Что-то пошло не так на нашей стороне. Мы уже чиним, попробуйте авторизоваться чуть позже, спасибо!")
        })
        .finally(()=>{
          vm.pending = false
          vm.startTimer()
        })
    },
    sendValidateCode: function () {
      let vm = this;
      if (vm.pending) return
      vm.pending = true
      vm.$api.validateAuthCode(vm.userPhone, vm.validateCode)
      .then(data=>{
            vm.SET_USER_TOKEN(data.token);
            if (data.first_name.length < 2){
              vm.step = 'USERNAME'
              vm.$nextTick(()=>vm.$refs.inputName.focus())
            } else {
              return vm.finishAuth(data)
            }
          })
          .then(() => vm.$api.checkAuth())
          .then(data=>{
            if (data.vk_exists === false) {
              window.location.href = window.location.href + '?wizard=true'
            }
          })
          .catch(function (error) {
            let response = error.response
            if (response.data &&
                response.data.detail &&
                response.data.detail.toLowerCase().includes('invalid')){
                vm.errorCodeModal = 'Неправильный код!'
                return vm.$toast.error('Неправильный код')
            }
            vm.$toast.error('Что-то пошло не так...');
          }).finally(()=>vm.pending = false)
    },
    setUserName: function () {
      let vm = this;
      if (vm.pending) return
      vm.pending = true
      vm.$api.updateUserPut({'first_name': vm.userName})
        .then(function (response) {
          vm.finishAuth(response.data)
        })
        .catch(function (error){
          vm.$toast.error(error);
        }).finally(()=>vm.pending = false)
    },
    async finishAuth(data) {
      this.SET_USER_FIELDS(data);
      await this.GET_USER_DETAILS();
      this.step = ''
      this.validateCode = ''
      this.userPhone = ''
      this.userName = ''
      if (this.$store.state.targetClick) {
        console.log('TARGET CLICK >> ', this.$store.state.targetClick);
        try{
          this.$store.state.targetClick.click();
        } finally {
          this.$store.dispatch('SET_TARGET_CLICK_ELEMENT', null)
        }
      }
      // Если URL содержит "preorder", перезагружаем текущую страницу
      if (this.$route.path.includes('preorder')) {
        console.log('PREORDER PAGE DETECTED, RELOADING...');
        window.location.reload();
        return;
      }
      if (this.$route.query.from) {
        console.log('REDIRECT TO', this.$route.query.from);
        this.$router.push(this.$route.query.from)
      } else if (this.$route.name === 'login'){
        this.$router.push('/')
      }
      this.resolvePromise()
    },
    handleVkAuthSuccess(data) {
      // Обработка успешной авторизации через VK
      this.finishAuth(data);
    },
    handleVkAuthError(error) {
      // Ошибка уже обработана в VkAuthButton, здесь можно добавить дополнительную логику
      console.error('VK Auth Error in Login component:', error);
    },
    checkPolicyAccepted() {
    if (this.isPolicyAccepted) {
        return true
      }

      this.policyError = true

      setTimeout(() => {
        this.policyError = false
      }, 1200)

      return false
    },
    checkPersonalDataAccepted() {
      if (this.isPersonalDataAccepted) {
        return true
      }

      this.personalDataError = true

      setTimeout(() => {
        this.personalDataError = false
      }, 1200)

      return false
    },
    areAllCheckboxesAccepted() {
      return this.isPolicyAccepted && this.isPersonalDataAccepted
    },
    checkAllCheckboxes() {
      let allOk = true
      if (!this.isPolicyAccepted) {
        this.policyError = true
        setTimeout(() => { this.policyError = false }, 1200)
        allOk = false
      }
      if (!this.isPersonalDataAccepted) {
        this.personalDataError = true
        setTimeout(() => { this.personalDataError = false }, 1200)
        allOk = false
      }
      return allOk
    },
    handleValidationFailed() {
      // Ошибки уже показаны через checkAllCheckboxes
    },

  },
  beforeUnmount() {
    if (this.rejectPromise) this.rejectPromise()
    if (this.resendTimerInterval) clearInterval(this.resendTimerInterval)
  }
}
</script>

<style scoped>
.modal-footer {
  border: none;
}
.window {
  max-width: 340px;
  margin: 0 auto;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.loaderInInput{
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(50%, -50%);
  margin-right: 3rem;
}
.vk-auth-container{
  margin: 10px 10px 20px 40px;
}
.policy-box {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-top: 18px;
  padding: 16px;
  border-radius: 22px;
  background: #35358d;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.25s ease;
}

.policy-box--active {
  border-color: #b26cff;
}

.policy-box--error {
  border-color: #ff4d6d;
  box-shadow: 0 0 12px rgba(255, 77, 109, 0.5);
}

.policy-checkbox {
  min-width: 28px;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff2b9c;
  margin-top: 2px;
}

.policy-text {
  font-size: 14px;
  line-height: 1.4;
  color: #fff;
}

.policy-text a {
  color: #fff;
  text-decoration: underline;
}
.policy-modal-overlay {
  position: fixed;
  inset: 0;

  background: rgba(0,0,0,0.55);

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 9999;

  padding: 20px;
}

.policy-modal {
  position: relative;

  width: 100%;
  max-width: 420px;

  max-height: 85vh;

  background: #35358d;

  border-radius: 28px;

  padding: 28px 24px;

  box-shadow:
    0 20px 60px rgba(0,0,0,0.35);

  overflow: hidden;
}

.policy-modal-title {
  color: white;

  font-size: 28px;
  font-weight: 700;

  line-height: 1.2;

  margin-bottom: 24px;

  text-align: center;
}

.policy-modal-content {
  overflow-y: auto;

  max-height: calc(85vh - 120px);

  padding-right: 8px;

  color: white;

  font-size: 16px;
  line-height: 1.6;
}

.policy-modal-content p {
  margin-bottom: 20px;
}

.policy-modal-close {
  position: absolute;

  top: 14px;
  right: 14px;

  width: 34px;
  height: 34px;

  border: none;
  border-radius: 50%;

  background: rgba(255,255,255,0.15);

  color: white;

  font-size: 24px;

  cursor: pointer;

  transition: .2s;
}

.policy-modal-close:hover {
  background: rgba(255,255,255,0.25);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>